import { XMarkIcon } from "@heroicons/react/24/outline";
import CategoryHashtag from "./CategoryHashtag";

interface IRaisedInfoProps {
  raised: boolean;
  id: string;
  title: string;
  integration_object_id: string;
  object_url: string;
  categories: string[];
  toggleInfo: React.MouseEventHandler<SVGSVGElement>;
  taggedFeed: (category: string) => void;
}
const RaisedInfo = ({
  raised,
  id,
  title,
  integration_object_id,
  object_url,
  categories,
  toggleInfo,
  taggedFeed
}: IRaisedInfoProps) => {
  const boxClasses = `${
    raised
      ? "dropdown-content w-72 border-2 border-zinc-700 bg-zinc-800"
      : " hidden "
  }`;

  return (
    <div tabIndex={0} className={boxClasses + " p-2 bg-zinc-300"}>
      <div className="z-100 bg-opacity-95 rounded-lg shadow bg-zinc-800 relative">
        <XMarkIcon
          onClick={toggleInfo}
          className="absolute right-1 top-1 mx-auto text-xl h-4 w-4 dark:text-white"
          style={{ cursor: "pointer" }}
        />
        <br />
        <h1
          className="text-sm text-slate-50"
          style={{
            fontFamily: "Courier Prime",
          }}
        >
          <b>id:</b> {id}
          <br />
          <b>title:</b> {title}
          <br />
          <b>integration_object_id: </b> {integration_object_id}
          <br />
          <b>object_url: </b> {object_url}
          <br />
        </h1>
        <br />
        <div className="overflow-scroll text-slate-50 left-0 right-0 bottom-0 top-0 h-full">
          {categories &&
            categories.map((category: string) => {
              return (
                <CategoryHashtag
                  category={category}
                  taggedFeed={(ev: any, category: string) => {
                    taggedFeed(category);
                    toggleInfo(ev);
                  }}
                />
              );
            })}
        </div>
        <p className="text-xs">
          <i>
            Most of the above information is diagnostic. You can click or touch
            the title of the work to see the description.
          </i>
        </p>
      </div>
    </div>
  );
};

export default RaisedInfo;
              // {
              //   showMoreInfo &&
              //     video.integration_categories &&
              //     video.integration_categories.map(
              //       (integration_category: string) => {
              //         return (
              //           <span className="py-1 px-2 shadow-md no-underline rounded-full bg-slate-400 text-white font-sans font-semibold text-sm border-slate-400 btn-primary hover:text-white hover:bg-slate-500 active:shadow-none mr-2">
              //             {integration_category}
              //           </span>
              //         );
              //       }
              //     );
              // }